import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71903228"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-col-centered selection stretch",
  style: {"row-gap":"20px"}
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["onUpdate:modelValue"]

import { ref, computed, watch, inject } from "vue";
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';
import BaseContractPage from "./BaseContractPage.vue";
import IContractPageExpose from '@/Interfaces/components/IContractPageExpose';
import IContractApproval from "@/Interfaces/Contract/IContractApproval";
import { contractApproval } from "@/services/network";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import NotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import { authService } from "@/auth/authSingleton";
import DateTimeLocalStr from "@/types/DateTimeLocalStr";
import TickCrossBooleanDisplay from "@/components/TickCrossBooleanDisplay.vue";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
import ToggleButton from "@/components/ToggleButton.vue";
import { AuthorisationLevel, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import RadioButtonToggle from "@/components/common/RadioButtonToggle.vue";
import LabeledInputContainer from "@/components/common/LabeledInputContainer.vue";
import DropdownTopArray from "@/components/common/DropdownTopArray.vue";
import ContractApprovalDownloadPopUp from "./ContractApproval/ContractApprovalDownloadPopUp.vue";   
import { loggerKey } from "@/types/ServiceKeys";

enum ApproveFilter {
    NonApproved,
    Null,
    Approved,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContractApproval',
  setup(__props) {


const basePage = ref<IContractPageExpose<IContractApproval>>();
const colBase = [
        'contractID',
        'approved',
        'performedBy',
        'performDate',
        'ownerID',
        //'customerID',
        //'orderID',
        //'market',
        'status',
        //'hasFileData',
        'initialDate',
        'activationDate',
        'terminationDate',
    ] as (keyof IContractApproval)[];
const validationCols = computed(()=>{
    const data = basePage?.value?.downloadedContracts;
    const validationColSet = new Set<keyof IContractApproval>([
        'hireAgreementValidation',
        'customerInvoiceValidation',
        'carSaleInvoiceValidation',
        'underwritingValidation',
    ]);
    data?.forEach(x=>{
        Object.entries(x).forEach(([k,v])=>{
            if (typeof v === 'boolean') {
                if (k.includes('Valid')) {
                    validationColSet.add(k as keyof IContractApproval);
                }
            }
        });
    });
    return [...validationColSet.keys()];
});
const toDownloadCol = computed(()=>((approveFilterChoice.value !=2)?[]:["toDownload"] as (keyof IContractApproval)[]));
const cols = computed<(keyof IContractApproval)[]>(()=>[...toDownloadCol.value ,...colBase, ...validationCols.value]);
const working = ref(false);
const approving = ref(true);
const downloadToggle = ref(false);
const approveAccess = computed(()=>!DenyFunctionLevelAccess(AuthorisationLevel.Analyst));
const checkableFilter = computed(()=>approving.value ? isValidAndNonApproved : ()=>true);
const contractsToDownload = ref();
const visibleRows = computed(() => basePage.value?.getTableRef()?.GetFiltered());
const log = inject(loggerKey);

watch(visibleRows, currentRows => {
    if(approveFilterChoice.value!=2) return;
    log?.debug("watch event triggered");
    downloadToggle.value = !currentRows?.some(row => !row.toDownload);
});

// Filtering
const statusOptions = computed(()=>basePage.value?.getTableRef()?.GetFiltered()?.map(x => x.status) ?? []);
const statusFilter = ref<string|null>(null);

const approveFilerChoices = {
    [ApproveFilter.NonApproved]: 'Non-approved',
    [ApproveFilter.Null]: 'No Filter',
    [ApproveFilter.Approved]: 'Approved'
}
const approveFilterChoice = ref(ApproveFilter.Null);
const approveFilters = {
    [ApproveFilter.NonApproved]: (x: IContractApproval)=>!x.approved,
    [ApproveFilter.Null]: undefined,
    [ApproveFilter.Approved]: (x: IContractApproval)=>x.approved,
}
const approveFilter = computed(()=>approveFilters[approveFilterChoice.value]);
const showDownload = computed(()=> approveFilterChoice.value == 2);
const contractFilters = computed(()=>[
    approveFilter.value, 
    statusFilter.value ? 
        (x: IContractApproval)=>x.status === statusFilter.value : 
        undefined
].filter((x):x is ((x: IContractApproval) => boolean) => !!x));

function isValidAndNonApproved(row: IContractApproval) {
    return allValid(row) && !row.approved;
}
function allValid(row: IContractApproval) {
    const anyInvalid = Object.entries(row).some(([k,v])=>{
        if (typeof v === 'boolean') {
            if (k.includes('Valid')) {
                return !v;
            }
        }
    });
    return !anyInvalid;
}
function updatetDownloandToggle(event){
    if (!event.target.checked) {
        downloadToggle.value=false
    }
    if(event.target.checked &&  basePage.value?.getTableRef()?.GetFiltered()?.filter(x=>x.toDownload).length == basePage.value?.getTableRef()?.GetFiltered()?.length){
        downloadToggle.value=true
    }
}
async function contractGetAPI(data) {
    if (data.lookupDate === 'ACTIVATION_DATE') {
        data.activationDateFrom = data.dateFrom;
        data.activationDateTo = data.dateTo;
    } else if (data.lookupDate === 'INITIAL_DATE') {
        data.initialDateFrom = data.dateFrom;
        data.initialDateTo = data.dateTo;
    }
    const result = (await contractApproval.get(data)).data;
    result.forEach(x=>
        {x.performDate=x.performDate?new DateTimeLocalStr(x.performDate):undefined
        x.toDownload = downloadToggle.value
    });
    return result;
}
async function approveReject(approve: boolean) {
    if (working.value) return;
    working.value = true;
    const close = useSpinnerPopup().show();
    try {
        if (!basePage.value) throw new ReferenceError('Base view is not mounted');
        const username = authService.getEmailAddress();
        const contractIDs = basePage.value.getSelected();
        if (contractIDs.length<=0) return;
        await contractApproval.post({
            username,
            contractIDs,
            approve
        });
        basePage.value.searchContracts();
        const actionText = approve ? 'approved' : 'disapproved';
        NotifierWithErrFormatter().success({ msg: `Successfully ${actionText} contracts` });
    } catch (error) {
        const actionText = approve ? 'Approving' : 'Disapproving';
        await NotifierWithErrFormatter().error({ errorType: `${actionText} Contracts`, error });
    } finally {
        working.value = false;
        close();
    }
}
function onDownloadClicked(){
    const setContractsToDownload = basePage.value?.getTableRef()?.GetFiltered()?.filter(x=>x.toDownload);
    if(setContractsToDownload?.length){
        contractsToDownload.value =  setContractsToDownload;    
    }else{
        useNotifierWithErrFormatter().notify({msg: 'No contracts have been selected for download.'});
    }
}
async function approve() {
    approveReject(true);
}
async function disapprove() {
    approveReject(false);
}
function checkAllContractsForDownload(checkAll?: boolean) {
    visibleRows.value?.forEach(x=>x.toDownload = checkAll);
}
function approveFilterChange(){
    basePage.value?.clearChecked()
    if(approveFilterChoice.value != 2){
        downloadToggle.value = false
        basePage.value?.downloadedContracts?.forEach(x=>x.toDownload = undefined);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseContractPage, {
    ref_key: "basePage",
    ref: basePage,
    loadAllByDefault: "",
    hasCheckbox: "",
    contractName: "",
    rowFilters: contractFilters.value,
    rowCheckableFilter: checkableFilter.value,
    contractGetAPI: contractGetAPI,
    cols: cols.value,
    seMarketEnable: ""
  }, _createSlots({
    approved: _withCtx(({value}) => [
      _createVNode(TickCrossBooleanDisplay, {
        value: value.approved
      }, null, 8, ["value"])
    ]),
    "filter-group-extra": _withCtx(() => [
      _createVNode(LabeledInputContainer, {
        id: "contract-status",
        title: "Status Filter"
      }, {
        default: _withCtx(() => [
          _createVNode(DropdownTopArray, {
            id: "contract-status",
            placeholder: "No Filter",
            modelValue: statusFilter.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((statusFilter).value = $event)),
            options: statusOptions.value
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      })
    ]),
    "search-group-extra": _withCtx(() => [
      _createVNode(RadioButtonToggle, {
        name: "approve-filter",
        modelValue: approveFilterChoice.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((approveFilterChoice).value = $event)),
        options: approveFilerChoices,
        onChange: approveFilterChange
      }, null, 8, ["modelValue"])
    ]),
    toDownload: _withCtx(({value}) => [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": ($event: any) => ((value.toDownload) = $event),
        class: "centre-text vtl-checkbox",
        onChange: _cache[7] || (_cache[7] = ($event: any) => (updatetDownloandToggle($event)))
      }, null, 40, _hoisted_5), [
        [_vModelCheckbox, value.toDownload]
      ])
    ]),
    _: 2
  }, [
    (approveAccess.value)
      ? {
          name: "header-extra",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(LabeledInputContainer, {
                title: "Toggle (Dis)approve",
                id: "toggle-approve"
              }, {
                title: _withCtx(({value}) => [
                  _createTextVNode(_toDisplayString(value) + " ", 1),
                  _createVNode(ToggleButton, {
                    id: "toggle-approve",
                    modelValue: approving.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((approving).value = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (basePage.value?.clearChecked()))
                  }, null, 8, ["modelValue"])
                ]),
                default: _withCtx(() => [
                  _createVNode(GroupedInputButton, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "default-btn",
                        disabled: working.value || approving.value,
                        title: 'Disapprove selected contracts',
                        onClick: disapprove,
                        type: "button"
                      }, " Disapprove ", 8, _hoisted_2),
                      _createElementVNode("button", {
                        class: "default-btn right-btn",
                        disabled: working.value || !approving.value,
                        title: 'Approve selected contracts',
                        onClick: approve,
                        type: "button"
                      }, " Approve ", 8, _hoisted_3)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (showDownload.value)
                ? (_openBlock(), _createBlock(LabeledInputContainer, {
                    key: 0,
                    class: "flex-col-centered selection stretch",
                    title: "Select all for download",
                    id: "toggle-all-download"
                  }, {
                    title: _withCtx(({value}) => [
                      _createTextVNode(_toDisplayString(value) + " ", 1),
                      _createVNode(ToggleButton, {
                        id: "toggle-all-download",
                        modelValue: downloadToggle.value,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((downloadToggle).value = $event)),
                          checkAllContractsForDownload
                        ]
                      }, null, 8, ["modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "download-btn default-btn right-btn",
                        disabled: working.value || !approving.value,
                        title: 'Approve selected contracts',
                        onClick: onDownloadClicked,
                        type: "button"
                      }, " Download ", 8, _hoisted_4)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(ContractApprovalDownloadPopUp, {
              modelValue: contractsToDownload.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((contractsToDownload).value = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (downloadToggle.value=false))
              ]
            }, null, 8, ["modelValue"])
          ]),
          key: "0"
        }
      : undefined,
    _renderList(validationCols.value, (k) => {
      return {
        name: `${k}`,
        fn: _withCtx(({value}) => [
          _createVNode(TickCrossBooleanDisplay, {
            value: (value[k] as boolean)
          }, null, 8, ["value"])
        ])
      }
    })
  ]), 1032, ["rowFilters", "rowCheckableFilter", "cols"]))
}
}

})